import {
    AfterViewInit,
    ComponentFactoryResolver,
    ComponentRef,
    Directive,
    ElementRef,
    EventEmitter,
    Injector,
    Input,
    OnDestroy,
    Output,
    Type,
    ViewContainerRef,
} from '@angular/core';

// https://github.com/angular/angular/issues/15360
/*
  USAGE:

    <div myComponentOutlet
           [component]="inner.component"
           [injector]="inner.injector"
           (create)="componentCreated($event)"></div>
 */

@Directive({
    selector: '[fiComponentOutlet]',
    standalone: false,
})
export class FiComponentOutletDirective<T> implements AfterViewInit, OnDestroy {
    @Input('fiComponentOutlet') component: Type<T>;
    @Input() injector: Injector;
    @Output() componentCreate = new EventEmitter<ComponentRef<T>>();
    @Output() componentDestroy = new EventEmitter<ComponentRef<T>>();

    private componentRef: ComponentRef<T>;

    constructor(
        private viewContainerRef: ViewContainerRef,
        private resolver: ComponentFactoryResolver,
        private elRef: ElementRef,
        private globalInjector: Injector,
    ) {
        this.injector = globalInjector;
    }

    ngAfterViewInit() {
        const injector = this.injector || this.globalInjector;
        const factory = this.resolver.resolveComponentFactory(this.component);
        this.componentRef = this.viewContainerRef.createComponent(factory, 0, injector);

        this.elRef.nativeElement.appendChild(this.componentRef.location.nativeElement);
        this.componentCreate?.emit(this.componentRef);
    }

    ngOnDestroy(): void {
        this.componentDestroy?.emit(this.componentRef);
    }
}
